import { CommonModule } from '@angular/common';
// tslint:disable-next-line:max-line-length
import { ComponentFactoryResolver, Directive, ElementRef, Input, NgModule, ViewContainerRef } from '@angular/core';
import { ThemePalette } from '@angular/material/core';
import { MatProgressSpinnerModule, MatSpinner } from '@angular/material/progress-spinner';

@Directive({
  // tslint:disable-next-line:directive-selector
  selector: '[to-save-button]',
  exportAs: 'toSaveButton',
})
export class SaveButtonDirective {

  private spinnerRef: HTMLElement;
  private isSaving = false;

  @Input() toSpinnerColor: ThemePalette = 'primary';

  // tslint:disable-next-line:no-input-rename
  @Input('to-save-button')
  get saving() {
    return this.isSaving;
  }
  set saving(value: boolean) {
    if (value) {
      const componentFactory = this.componentFactoryResolver.resolveComponentFactory(MatSpinner);
      const componentRef = this.viewContainerRef.createComponent(componentFactory);
      this.spinnerRef = componentRef.location.nativeElement;
      this.spinnerRef.style['vertical-align'] = 'middle';
      componentRef.instance.diameter = 20;
      componentRef.instance.color = this.toSpinnerColor;
      this.el.nativeElement.insertBefore(this.spinnerRef, this.el.nativeElement.childNodes[0]);
    }

    if (this.spinnerRef) {
      this.spinnerRef.style.display = value ? 'inline-block' : 'none';
    }
    
    this.el.nativeElement.disabled = value;
    this.isSaving = value;
  }

  constructor(
    private el: ElementRef,
    private viewContainerRef: ViewContainerRef,
    private componentFactoryResolver: ComponentFactoryResolver,
  ) { }

}

@NgModule({
  imports: [
    CommonModule,
    MatProgressSpinnerModule,
  ],
  declarations: [
    SaveButtonDirective,
  ],
  exports: [
    SaveButtonDirective,
    MatProgressSpinnerModule
  ],
  entryComponents: [
    MatSpinner
  ]
})
export class SaveButtonModule { }
